/**
 * Created by cxh on 10/29/2016.
 */
'use strict';
angular.module('betosyswebapp')
  .service('messageService', function (AuthenticationService, webSocketService, $rootScope, commonTrackService,AdmFramworkService) {
    var messageCallback;

    this.initialize = function () {
      var loginID = AuthenticationService.GetLoginID();
      if (loginID) {
        var subscribeID = '/topic/' + loginID.Account;
        var uuid=AdmFramworkService.getBrowserUUID();
        var clientID = loginID.Account + '-' + loginID.username + '-' + uuid;
        var fleetServerDetails;
        commonTrackService.getFleetServerDetails().then(function (fleetDetails) {
          fleetServerDetails = fleetDetails;
          if(fleetServerDetails.instantMessageEnabled || fleetServerDetails.instantJobEvntEnabled){
            webSocketService.connect(clientID);
            webSocketService.subscribe(subscribeID, clientID);
          }
        }).then(function () {
          if (!messageCallback) {
            messageCallback = function (data) {
              var headers = data.headers;
              var message = JSON.parse(data.body);
              console.log(headers);
              console.log(message);
              if (message.instanceResponseType === 'instant_message' && fleetServerDetails.instantMessageEnabled) {
                $rootScope.$broadcast('msg-event', message);
              }
              if (message.instanceResponseType === 'instant_jobEvent' && fleetServerDetails.instantJobEvntEnabled) {
                $rootScope.$broadcast('job-event', message);
              }
            };

            webSocketService.receive().then(null, null, messageCallback);
          }
        });

      }
    };




    this.deInitialize = function () {
      webSocketService.unsubscribe();
      webSocketService.disconnect();
    };

  });



// WEBPACK FOOTER //
// ./.tmp/components/common/services/messageService.js